"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const UserDefinition_1 = require("./UserDefinition");
class UserCommand {
    static AddContactCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.AddContact)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static HideContactCommand(userId, c, cmdType) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.HideContact)
            .CmdTypeAction(cmdType || RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static BlockContactCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.BlockContact)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static RemoveContactCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.RemoveContact)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static RecoverContactCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.RecoverContact)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static AddContactToFavoriteCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.AddContactToFavorite)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static RemoveContactFromFavoriteCommand(userId, c, cmdType = RtcCommand_1.CmdType.RequestExecute) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.RemoveContactFromFavorite)
            .CmdTypeAction(cmdType)
            .IsToService(true)
            .TargetId(userId)
            .Content(c)
            .Build();
    }
    static FetchContactStatusRequestExecuteCommand(userId) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchContactStatus)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .TargetId(userId)
            .Build();
    }
    static FetchContactStatusResponseAcceptCommand(userId, rtcCmd, contacts) {
        return RtcCommand_1.RtcCommand.Builder().Id(rtcCmd.id)
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchContactStatus)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .AddReceiver(rtcCmd.sender)
            .TargetId(userId)
            .Content(contacts)
            .Build();
    }
    static FetchAllUserRequestExecuteCommand() {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchAllUser)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .Build();
    }
    static FetchAllUserRequestAcceptCommand(fromCmd, fetchedUsers) {
        return RtcCommand_1.RtcCommand.Builder().Id(fromCmd.id)
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchAllUser)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .AddReceiver(fromCmd.sender)
            .Content(fetchedUsers)
            .Build();
    }
    static FetchUserCommand(idAndName) {
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchUser)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .IsToService(true)
            .Content(idAndName)
            .Build();
    }
    static FetchUserAcceptCommand(fromCmd, fetchedUser) {
        return RtcCommand_1.RtcCommand.Builder().Id(fromCmd.id)
            .Category(UserCommand.Category)
            .Name(UserCommand.FetchUser)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseAccept)
            .AddReceiver(fromCmd.sender)
            .Content(fetchedUser)
            .Build();
    }
}
UserCommand.Category = UserDefinition_1.UserCommandCategory;
UserCommand.AddContact = "AddContact";
UserCommand.HideContact = "HideContact";
UserCommand.BlockContact = "BlockContact";
UserCommand.RemoveContact = "RemoveContact";
UserCommand.RecoverContact = "RecoverContact";
UserCommand.AddContactToFavorite = "AddContactToFavorite";
UserCommand.RemoveContactFromFavorite = "RemoveContactFromFavorite";
UserCommand.FetchContactStatus = "FetchContactStatus";
UserCommand.FetchAllUser = "FetchAllUser";
UserCommand.FetchUser = "FetchUser";
exports.UserCommand = UserCommand;
//# sourceMappingURL=UserCommand.js.map